export interface ShowcaseProduct {
  name: string;
  slug: string;
  image: string;
}

export interface ShowcaseCategory {
  key: string;
  name: string;
  en: string;
  href: string;
  products: ShowcaseProduct[];
}

export const productShowcaseTabs = {
  eyebrow: '产品矩阵',
  title: '智慧停车产品展示',
  subtitle:
    '路内停车设备与停车场设备两大类硬件，覆盖车辆探测、身份识别、通道控制与诱导引导，构建城市停车数字化的感知与管控底座。',
};

export const productShowcaseCategories: ShowcaseCategory[] = [
  {
    key: 'onstreet',
    name: '路内停车设备',
    en: 'On-street Parking',
    href: '/products',
    products: [
      {
        name: 'LORA车辆探测器',
        slug: 'lora-vehicle-detector',
        image:
          'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24692584.png',
      },
      {
        name: 'NB-IOT车辆探测器',
        slug: 'nbiot-vehicle-detector',
        image:
          'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24692584.png',
      },
      {
        name: '网关',
        slug: 'gateway',
        image:
          'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24692587.png',
      },
      {
        name: 'PDA手持终端',
        slug: 'pda-terminal',
        image:
          'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24692589.png',
      },
      {
        name: '车载卡',
        slug: 'onboard-card',
        image:
          'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24692590.png',
      },
      {
        name: 'RFID读卡器',
        slug: 'rfid-reader',
        image:
          'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24692591.png',
      },
      {
        name: 'RFID雷达探测读卡器',
        slug: 'rfid-radar-reader',
        image:
          'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24692586.png',
      },
      {
        name: 'AI智能停车视频取证巡检终端',
        slug: 'ai-parking-video-terminal',
        image:
          'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/52330980.png',
      },
    ],
  },
  {
    key: 'parking-lot',
    name: '停车场设备',
    en: 'Parking Lot',
    href: '/products',
    products: [
      {
        name: '高速道闸',
        slug: 'high-speed-barrier',
        image:
          'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24693318.png',
      },
      {
        name: '车牌识别一体机',
        slug: 'plate-recognition',
        image:
          'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24693317.png',
      },
      {
        name: '显示屏幕',
        slug: 'display-screen',
        image:
          'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24696576.png',
      },
      {
        name: '补光灯',
        slug: 'fill-light',
        image:
          'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24693316.png',
      },
      {
        name: '车位锁',
        slug: 'parking-lock',
        image:
          'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24693321.png',
      },
      {
        name: '诱导屏',
        slug: 'guidance-screen',
        image:
          'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24693320.png',
      },
      {
        name: '吊顶式车辆探测器',
        slug: 'ceiling-vehicle-detector',
        image:
          'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24692585.png',
      },
    ],
  },
];